import styled from 'styled-components'

export const RewardContainer = styled.div`
  display: grid;
  grid-template-areas:
    'logo title'
    'logo values'
    'content content';
  grid-template-columns: 70px 1fr;
  grid-template-rows: repeat(3, auto);
  padding: 0 25px 20px;
  max-width: 320px;
  width: 100%;
  margin: 0 auto;
  gap: 5px;
`

export const RewardImageContainer = styled.div`
  grid-area: logo;
  display: flex;
  width: 70px;
  height: 70px;
  align-items: center;
  justify-content: center;
`

export const RewardImage = styled.img`
  max-width: 100%;
  max-height: 100%;
`

export const RewardName = styled.div`
  grid-area: title;
  flex: 1;
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
  align-self: flex-end;
`

export const RewardRedemptionValues = styled.div`
  grid-area: values;
  font-size: 18px;
  line-height: 24px;
  text-transform: lowercase;
  align-self: flex-start;
`

export const RewardContent = styled.div`
  grid-area: content;
`

export const RewardDescription = styled.div`
  font-size: 18px;
  line-height: 24px;
`

export const RewardDescriptionTitle = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
`

export const RewardDescriptionText = styled.div`
  font-size: 18px;
  line-height: 24px;
  margin-top: 5px;
`
